// extracted by mini-css-extract-plugin
export var container = "_dw-0";
export var containerTopRight = "_dw-1";